import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Seo } from '../components/seo/Seo';

export function NotFoundPage() {
  const location = useLocation();

  return (
    <>
      <Seo
        title="Page not found | Med900"
        description="This Med900 page does not exist. Return to the UCAT practice platform homepage."
        path={location.pathname}
        robots="noindex, follow"
      />
      <main className="min-h-screen bg-background flex items-center justify-center px-6">
        <div className="max-w-md text-center space-y-4">
          <p className="text-sm font-medium text-muted-foreground">404</p>
          <h1 className="font-cabinet text-3xl font-black tracking-tight">Page not found</h1>
          <p className="text-muted-foreground font-plex">
            This URL is not a public Med900 page, so it should not be indexed.
          </p>
          <Link
            to="/"
            className="inline-flex items-center justify-center rounded-full bg-gray-950 px-5 py-2.5 text-sm font-semibold text-white hover:bg-gray-800"
          >
            Back to home
          </Link>
        </div>
      </main>
    </>
  );
}
